module.exports = __webpack_public_path__ + "9b208d758e785bd38298a5b05fb93f7f.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/components/InteractiveExample/de/6.m4a
// module id = 975
// module chunks = 4